import { farasod } from "./api"

const endpoint = "/setting"

export const getSettings = async () => {
  const response = await farasod.get(`${endpoint}`)

  return response.data
}

export const editSettings = async data => {
  const response = await farasod.patch(`${endpoint}`, data)

  return response.data
}

export const getShareholders = async () => {
  const response = await farasod.get(`${endpoint}/shareholder`)

  return response.data
}

export const getTaxItems = async () => {
  const response = await farasod.get(`${endpoint}/tax`)

  return response.data
}

export const addTaxItem = async (data) => {
  const response = await farasod.post(`${endpoint}/tax`, data)

  return response.data
}

export const editTaxItem = async (taxId, data) => {
  const response = await farasod.patch(`${endpoint}/tax/${taxId}`, data)

  return response.data
}

export const deleteTaxItem = async (taxId) => {
  const response = await farasod.delete(`${endpoint}/tax/${taxId}`)

  return response.data
}

export const getCashierAccesses = async () => {
  const response = await farasod.get(`${endpoint}/access`)

  return response.data
}

export const getClientnameFromServer = async (domain) => {
  const response = await farasod.get(
    `${endpoint}/client_name/${encodeURIComponent(domain)}`
  )

  return response.data
}

export const getPaymentSecretKeys = async () => {
  const response = await farasod.get(`${endpoint}/payment-secrets`)

  return response.data
}

export const changePaymentSecretKeys = async (data) => {
  const response = await farasod.patch(`${endpoint}/payment-secrets`, data)

  return response.data
}
